var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tokenlogin"},[_c('div',{staticClass:"first-loading-wrp"},[_c('div',{staticClass:"loading-wrp"},[_c('span',{staticClass:"dot dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])]),_c('h2',[_vm._v("悦融易融资超市（资金端）欢迎你")])])])
}]

export { render, staticRenderFns }